import { FeatureGroup, FeatureMap, RawAccess } from './types';

export const featureGroups: FeatureGroup[] = [
    {
        id: 1,
        name: 'USUARIOS',
        features: [
            { key: 'GESTION_USUARIOS', id: 1 },
            { key: 'ALTA_USUARIO', id: 2 },
            { key: 'EDICION_USUARIO', id: 3 },
            { key: 'CONSULTA_USUARIO', id: 4 },
            { key: 'ASIGNACION_ESTABLECIMENTO_USUARIO', id: 13 }
        ]
    },
    {
        id: 2,
        name: 'ADMINISTRACION',
        features: [
            { key: 'GESTION_ROLES', id: 5 },
            { key: 'ALTA_ROLES', id: 6 },
            { key: 'EDICION_ROLES', id: 7 },
            { key: 'CONSULTA_ROLES', id: 8 }
        ]
    },
    {
        id: 3,
        name: 'ESTABLECIMIENTOS',
        features: [
            { key: 'GESTION_ESTABLECIMIENTOS', id: 9 },
            { key: 'ALTA_ESTABLECIMIENTOS', id: 10 },
            { key: 'EDICION_ESTABLECIMIENTOS', id: 11 },
            { key: 'CONSULTA_ESTABLECIMIENTOS', id: 12 },
            { key: 'SOLICITUD_BAJA_ESTABLECIMIENTO', id: 32 },
            { key: 'APROBACION_SOLICITUD_ESTABLECIMIENTO', id: 33 },
            { key: 'DESCARGA_EXCEL_ESTABLECIMIENTO', id: 35 }
        ]
    },
    {
        id: 4,
        name: 'PRESENTACIONES',
        features: [
            { key: 'GESTION_PRESENTACIONES', id: 14 },
            { key: 'ALTA_PRESENTACION', id: 15 },
            { key: 'EDICION_PRESENTACION', id: 16 },
            { key: 'CONSULTA_PRESENTACION', id: 17 },
            { key: 'ELIMINACION_PRESENTACION', id: 18 },
            { key: 'CAMBIAR_ESTADO_PRESENTACION', id: 34 },
            { key: 'VISUALIZACION_DE_DETALLE_PRESENTACION', id: 31 },
            { key: 'EDITAR_PRESENTACION_BO', id: 54 }
        ]
    },
    {
        id: 5,
        name: 'NOMINA',
        features: [
            { key: 'GESTION_NOMINA_EMPLEADOS', id: 19 },
            { key: 'GESTION_CERTIFICADO_DE_COBERTURA', id: 20 },
            { key: 'ASIGNACION_NOMINA_ESTABLECIMIENTO', id: 21 },
            { key: 'DESCARGA_NOMINA_EXCEL', id: 26 }
        ]
    },
    {
        id: 6,
        name: 'PUESTOS',
        features: [
            { key: 'GESTION_PUESTOS_DE_TRABAJO', id: 22 },
            { key: 'ALTA_PUESTO_DE_TRABAJO', id: 23 },
            { key: 'EDICION_PUESTO_DE_TRABAJO', id: 24 },
            { key: 'INACTIVACION_PUESTO_DE_TRABAJO', id: 25 }
        ]
    },
    {
        id: 7,
        name: 'ORGANISMOS',
        features: [
            { key: 'GESTION_ORGANISMOS', id: 27 },
            { key: 'ALTA_ORGANISMOS', id: 28 },
            { key: 'EDICION_ORGANISMOS', id: 29 },
            { key: 'INACTIVACION_ORGANISMOS', id: 30 }
        ]
    },
    {
        id: 8,
        name: 'VINCULACION_RGRL',
        features: [
            { key: 'GESTION_DE_PRESENTACIONES_VINCULACION_RGRL', id: 36 },
            { key: 'GENERACION_ARCHIVOS_SRT', id: 37 },
            { key: 'DESCARGA_PDF', id: 38 },
            { key: 'CARGA_RESPUESTA_SRT', id: 39 },
            { key: 'CONSULTA_DE_PRESENTACIONES_SRT', id: 42 }
        ]
    },
    {
        id: 9,
        name: 'CANCERIGENOS',
        features: [
            { key: 'GESTION_CANCERIGENOS', id: 43 },
            { key: 'ALTA_CANCERIGENOS', id: 44 },
            { key: 'EDICIÓN_CANCERIGENOS', id: 45 },
            { key: 'CONSULTA_CANCERIGENOS', id: 46 }
        ]
    },
    {
        id: 10,
        name: 'VISITAS',
        features: [
            { key: 'ALTA_DE_VISITAS', id: 50 },
            { key: 'GESTION_DE_VISITAS', id: 51 },
            { key: 'DESCARGA_DE_ACTA', id: 52 },
            { key: 'EDICION_ELIMINACION_RGRL_VEROSIMILITUD', id: 53 }
        ]
    },
    {
        id: 11,
        name: 'PERIODICOS',
        features: [
            { key: 'GESTION_DE_EMPLEADOS_EXPUESTOS', id: 55 },
            { key: 'GESTION_DE_CONVOCATORIAS', id: 56 }
        ]
    },
    {
        id: 12,
        name: 'VISITAS_RGRL',
        features: [{ key: 'GENERACION_ARCHIVOS_VISITAS', id: 57 }]
    },
    {
        id: 13,
        name: 'AVISO_DE_OBRA',
        features: [
            { key: 'GESTION_DE_AVISO_DE_OBRA', id: 59 },
            { key: 'ALTA_AVISO_DE_OBRA', id: 60 },
            { key: 'MODIFICACION_AVISO_DE_OBRA', id: 61 },
            { key: 'BAJA_AVISO_DE_OBRA', id: 62 },
            { key: 'EXTENSION_SUSPENSION_AVISO_DE_OBRA', id: 63 },
            { key: 'VISUALIZAR_AVISO_DE_OBRA', id: 64 }
        ]
    }
];

export const getAccessUrl = (
    access: RawAccess | null,
    groupId: number,
    functionalityId: number
): string | null => {
    return access?.[groupId]?.[functionalityId]?.url ?? null;
};

export const hasAccess = (
    access: RawAccess | null,
    groupId: number,
    functionalityId: number
): boolean => {
    return !!access?.[groupId]?.[functionalityId];
};

export const getAccessValues = (access: RawAccess | null): FeatureMap => {
    const accessMap: FeatureMap = {};

    featureGroups.forEach(({ id: groupId, features }) => {
        features.forEach(({ key, id: functionalityId }) => {
            const acc = access?.[groupId]?.[functionalityId];
            accessMap[key] = {
                url: acc?.url ?? null,
                hasAccess: !!acc
            };
        });
    });

    return accessMap;
};

// access-utils.ts
// import { RawAccess, FeatureMap } from './types';
// import { featureGroups } from './features';

// enum FeatureKeys {
//     GESTION_USUARIOS = 'GESTION_USUARIOS',
//     ALTA_USUARIO = 'ALTA_USUARIO',
//     EDICION_USUARIO = 'EDICION_USUARIO',
//     CONSULTA_USUARIO = 'CONSULTA_USUARIO',
//     GESTION_ROLES = 'GESTION_ROLES',
//     ALTA_ROLES = 'ALTA_ROLES',
//     EDICION_ROLES = 'EDICION_ROLES',
//     CONSULTA_ROLES = 'CONSULTA_ROLES',
//     GESTION_ESTABLECIMIENTOS = 'GESTION_ESTABLECIMIENTOS',
//     ALTA_ESTABLECIMIENTOS = 'ALTA_ESTABLECIMIENTOS',
//     EDICION_ESTABLECIMIENTOS = 'EDICION_ESTABLECIMIENTOS',
//     CONSULTA_ESTABLECIMIENTOS = 'CONSULTA_ESTABLECIMIENTOS',
//     SOLICITUD_BAJA_ESTABLECIMIENTO = 'SOLICITUD_BAJA_ESTABLECIMIENTO',
//     APROBACION_SOLICITUD_ESTABLECIMIENTO = 'APROBACION_SOLICITUD_ESTABLECIMIENTO',
//     DESCARGA_EXCEL_ESTABLECIMIENTO = 'DESCARGA_EXCEL_ESTABLECIMIENTO',
//     ASIGNACION_ESTABLECIMENTO_USUARIO = 'ASIGNACION_ESTABLECIMENTO_USUARIO',
//     GESTION_PRESENTACIONES = 'GESTION_PRESENTACIONES',
//     ALTA_PRESENTACION = 'ALTA_PRESENTACION',
//     EDICION_PRESENTACION = 'EDICION_PRESENTACION',
//     CONSULTA_PRESENTACION = 'CONSULTA_PRESENTACION',
//     ELIMINACION_PRESENTACION = 'ELIMINACION_PRESENTACION',
//     GESTION_ORGANISMOS = 'GESTION_ORGANISMOS',
//     ALTA_ORGANISMOS = 'ALTA_ORGANISMOS',
//     EDICION_ORGANISMOS = 'EDICION_ORGANISMOS',
//     INACTIVACION_ORGANISMOS = 'INACTIVACION_ORGANISMOS',
//     GESTION_NOMINA_EMPLEADOS = 'GESTION_NOMINA_EMPLEADOS',
//     GESTION_CERTIFICADO_DE_COBERTURA = 'GESTION_CERTIFICADO_DE_COBERTURA',
//     ASIGNACION_NOMINA_ESTABLECIMIENTO = 'ASIGNACION_NOMINA_ESTABLECIMIENTO',
//     DESCARGA_NOMINA_EXCEL = 'DESCARGA_NOMINA_EXCEL',
//     GESTION_PUESTOS_DE_TRABAJO = 'GESTION_PUESTOS_DE_TRABAJO',
//     ALTA_PUESTO_DE_TRABAJO = 'ALTA_PUESTO_DE_TRABAJO',
//     VISUALIZACION_DE_DETALLE_PRESENTACION = 'VISUALIZACION_DE_DETALLE_PRESENTACION',
//     EDICION_PUESTO_DE_TRABAJO = 'EDICION_PUESTO_DE_TRABAJO',
//     INACTIVACION_PUESTO_DE_TRABAJO = 'INACTIVACION_PUESTO_DE_TRABAJO',
//     CAMBIAR_ESTADO_PRESENTACION = 'CAMBIAR_ESTADO_PRESENTACION',
//     GESTION_DE_PRESENTACIONES_VINCULACION_RGRL = 'GESTION_DE_PRESENTACIONES_VINCULACION_RGRL',
//     GENERACION_ARCHIVOS_SRT = 'GENERACION_ARCHIVOS_SRT',
//     DESCARGA_PDF = 'DESCARGA_PDF',
//     CARGA_RESPUESTA_SRT = 'CARGA_RESPUESTA_SRT',
//     CONSULTA_DE_PRESENTACIONES_SRT = 'CONSULTA_DE_PRESENTACIONES_SRT',
//     GESTION_CANCERIGENOS = 'GESTION_CANCERIGENOS',
//     ALTA_CANCERIGENOS = 'ALTA_CANCERIGENOS',
//     EDICIÓN_CANCERIGENOS = 'EDICIÓN_CANCERIGENOS',
//     CONULSTA_CANCERIGENOS = 'CONULSTA_CANCERIGENOS',
//     ALTA_DE_VISITAS = 'ALTA_DE_VISITAS',
//     GESTION_DE_VISITAS = 'GESTION_DE_VISITAS',
//     DESCARGA_DE_ACTA = ' DESCARGA_DE_ACTA',
//     EDICION_ELIMINACION_RGRL_VEROSIMILITUD = ' EDICION_ELIMINACION_RGRL_VEROSIMILITUD',
//     EDITAR_PRESENTACION_BO = 'EDITAR_PRESENTACION_BO',
//     GESTION_PERIODICOS = 'GESTION_PERIODICOS',
//     GENERACION_ARCHIVOS_VISITAS = 'GENERACION_ARCHIVOS_VISITAS',
//     GESTION_CONVOCATORIAS = 'GESTION_CONVOCATORIAS'
// }

// interface Feature {
//     url: string | null;
//     hasAccess: boolean;
// }

// type Features = {
//     [key in FeatureKeys]: Feature;
// };

// const GROUP_ID = {
//     USUARIOS: 1,
//     ADMINISTRACION: 2,
//     ESTABLECIMIENTO: 3,
//     PRESENTACIONES: 4,
//     NOMINA: 5,
//     PUESTOS: 6,
//     ORGANISMOS: 7,
//     VINCULACION_RGRL: 8,
//     CANCERIGENOS: 9,
//     VISITAS: 10,
//     PERIODICOS: 11,
//     VISITAS_RGRL: 12
// };

// const FUNCTIONALITY_ID = {
//     GESTION_USUARIOS: 1,
//     ALTA_USUARIO: 2,
//     EDICION_USUARIO: 3,
//     CONSULTA_USUARIO: 4,
//     GESTION_ROLES: 5,
//     ALTA_ROLES: 6,
//     EDICION_ROLES: 7,
//     CONSULTA_ROLES: 8,
//     GESTION_ESTABLECIMIENTOS: 9,
//     ALTA_ESTABLECIMIENTOS: 10,
//     EDICION_ESTABLECIMIENTOS: 11,
//     CONSULTA_ESTABLECIMIENTOS: 12,
//     DESCARGA_EXCEL_ESTABLECIMIENTO: 35,
//     ASIGNACION_ESTABLECIMENTO_USUARIO: 13,
//     GESTION_PRESENTACIONES: 14,
//     ALTA_PRESENTACION: 15,
//     EDICION_PRESENTACION: 16,
//     CONSULTA_PRESENTACION: 17,
//     ELIMINACION_PRESENTACION: 18,
//     GESTION_NOMINA_EMPLEADOS: 19,
//     GESTION_CERTIFICADO_DE_COBERTURA: 20,
//     ASIGNACION_NOMINA_ESTABLECIMIENTO: 21,
//     GESTION_PUESTOS_DE_TRABAJO: 22,
//     ALTA_PUESTO_DE_TRABAJO: 23,
//     EDICION_PUESTO_DE_TRABAJO: 24,
//     INACTIVACION_PUESTO_DE_TRABAJO: 25,
//     DESCARGA_NOMINA_EXCEL: 26,
//     GESTION_ORGANISMOS: 27,
//     ALTA_ORGANISMOS: 28,
//     EDICION_ORGANISMOS: 29,
//     INACTIVACION_ORGANISMOS: 30,
//     VISUALIZACION_DE_DETALLE_PRESENTACION: 31,
//     SOLICITUD_BAJA_ESTABLECIMIENTO: 32,
//     APROBACION_SOLICITUD_ESTABLECIMIENTO: 33,
//     CAMBIAR_ESTADO_PRESENTACION: 34,
//     GESTION_DE_PRESENTACIONES_VINCULACION_RGRL: 36,
//     GENERACION_ARCHIVOS_SRT: 37,
//     DESCARGA_PDF: 38,
//     CARGA_RESPUESTA_SRT: 39,
//     CONSULTA_DE_PRESENTACIONES_SRT: 42,
//     GESTION_CANCERIGENOS: 43,
//     ALTA_CANCERIGENOS: 44,
//     EDICIÓN_CANCERIGENOS: 45,
//     CONSULTA_CANCERIGENOS: 46,
//     ALTA_DE_VISITAS: 50,
//     GESTION_DE_VISITAS: 51,
//     DESCARGA_DE_ACTA: 52,
//     EDICION_ELIMINACION_RGRL_VEROSIMILITUD: 53,
//     EDITAR_PRESENTACION_BO: 54,
//     GESTION_DE_EMPLEADOS_EXPUESTOS: 55,
//     GESTION_DE_CONVOCATORIAS: 56,
//     GENERACION_ARCHIVOS_VISITAS: 57,
//     ANALIZAR_ARCHIVO: 58
// };

// interface Access {
//     [key: number]: {
//         [key: number]: {
//             name: string;
//             url: string;
//             showInMenu: boolean;
//         };
//     };
// }

// const getAccessUrl = (
//     access: Access | null,
//     groupId: number,
//     functionalityId: number
// ): string | null => {
//     return access?.[groupId]?.[functionalityId]?.url || null;
// };

// const hasAccess = (access: any, groupId: number, functionalityId: number): boolean => {
//     return !!access?.[groupId]?.[functionalityId];
// };

// const functionalities = [
//     {
//         groupId: GROUP_ID.USUARIOS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_USUARIOS,
//         key: 'GESTION_USUARIOS'
//     },
//     {
//         groupId: GROUP_ID.USUARIOS,
//         functionalityId: FUNCTIONALITY_ID.ALTA_USUARIO,
//         key: 'ALTA_USUARIO'
//     },
//     {
//         groupId: GROUP_ID.USUARIOS,
//         functionalityId: FUNCTIONALITY_ID.EDICION_USUARIO,
//         key: 'EDICION_USUARIO'
//     },
//     {
//         groupId: GROUP_ID.USUARIOS,
//         functionalityId: FUNCTIONALITY_ID.CONSULTA_USUARIO,
//         key: 'CONSULTA_USUARIO'
//     },
//     {
//         groupId: GROUP_ID.ADMINISTRACION,
//         functionalityId: FUNCTIONALITY_ID.GESTION_ROLES,
//         key: 'GESTION_ROLES'
//     },
//     {
//         groupId: GROUP_ID.ADMINISTRACION,
//         functionalityId: FUNCTIONALITY_ID.ALTA_ROLES,
//         key: 'ALTA_ROLES'
//     },
//     {
//         groupId: GROUP_ID.ADMINISTRACION,
//         functionalityId: FUNCTIONALITY_ID.EDICION_ROLES,
//         key: 'EDICION_ROLES'
//     },
//     {
//         groupId: GROUP_ID.ADMINISTRACION,
//         functionalityId: FUNCTIONALITY_ID.CONSULTA_ROLES,
//         key: 'CONSULTA_ROLES'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.GESTION_ESTABLECIMIENTOS,
//         key: 'GESTION_ESTABLECIMIENTOS'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.ALTA_ESTABLECIMIENTOS,
//         key: 'ALTA_ESTABLECIMIENTOS'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.EDICION_ESTABLECIMIENTOS,
//         key: 'EDICION_ESTABLECIMIENTOS'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.SOLICITUD_BAJA_ESTABLECIMIENTO,
//         key: 'SOLICITUD_BAJA_ESTABLECIMIENTO'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.APROBACION_SOLICITUD_ESTABLECIMIENTO,
//         key: 'APROBACION_SOLICITUD_ESTABLECIMIENTO'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.CONSULTA_ESTABLECIMIENTOS,
//         key: 'CONSULTA_ESTABLECIMIENTOS'
//     },
//     {
//         groupId: GROUP_ID.ESTABLECIMIENTO,
//         functionalityId: FUNCTIONALITY_ID.DESCARGA_EXCEL_ESTABLECIMIENTO,
//         key: 'DESCARGA_EXCEL_ESTABLECIMIENTO'
//     },
//     {
//         groupId: GROUP_ID.USUARIOS,
//         functionalityId: FUNCTIONALITY_ID.ASIGNACION_ESTABLECIMENTO_USUARIO,
//         key: 'ASIGNACION_ESTABLECIMENTO_USUARIO'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.GESTION_PRESENTACIONES,
//         key: 'GESTION_PRESENTACIONES'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.CAMBIAR_ESTADO_PRESENTACION,
//         key: 'CAMBIAR_ESTADO_PRESENTACION'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.ALTA_PRESENTACION,
//         key: 'ALTA_PRESENTACION'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.EDICION_PRESENTACION,
//         key: 'EDICION_PRESENTACION'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.EDITAR_PRESENTACION_BO,
//         key: 'EDITAR_PRESENTACION_BO'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.VISUALIZACION_DE_DETALLE_PRESENTACION,
//         key: 'VISUALIZACION_DE_DETALLE_PRESENTACION'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.CONSULTA_PRESENTACION,
//         key: 'CONSULTA_PRESENTACION'
//     },
//     {
//         groupId: GROUP_ID.PRESENTACIONES,
//         functionalityId: FUNCTIONALITY_ID.ELIMINACION_PRESENTACION,
//         key: 'ELIMINACION_PRESENTACION'
//     },
//     {
//         groupId: GROUP_ID.ORGANISMOS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_ORGANISMOS,
//         key: 'GESTION_ORGANISMOS'
//     },
//     {
//         groupId: GROUP_ID.ORGANISMOS,
//         functionalityId: FUNCTIONALITY_ID.ALTA_ORGANISMOS,
//         key: 'ALTA_ORGANISMOS'
//     },
//     {
//         groupId: GROUP_ID.ORGANISMOS,
//         functionalityId: FUNCTIONALITY_ID.EDICION_ORGANISMOS,
//         key: 'EDICION_ORGANISMOS'
//     },
//     {
//         groupId: GROUP_ID.ORGANISMOS,
//         functionalityId: FUNCTIONALITY_ID.INACTIVACION_ORGANISMOS,
//         key: 'INACTIVACION_ORGANISMOS'
//     },
//     {
//         groupId: GROUP_ID.NOMINA,
//         functionalityId: FUNCTIONALITY_ID.GESTION_CERTIFICADO_DE_COBERTURA,
//         key: 'GESTION_CERTIFICADO_DE_COBERTURA'
//     },
//     {
//         groupId: GROUP_ID.NOMINA,
//         functionalityId: FUNCTIONALITY_ID.GESTION_NOMINA_EMPLEADOS,
//         key: 'GESTION_NOMINA_EMPLEADOS'
//     },
//     {
//         groupId: GROUP_ID.NOMINA,
//         functionalityId: FUNCTIONALITY_ID.ASIGNACION_NOMINA_ESTABLECIMIENTO,
//         key: 'ASIGNACION_NOMINA_ESTABLECIMIENTO'
//     },
//     {
//         groupId: GROUP_ID.NOMINA,
//         functionalityId: FUNCTIONALITY_ID.DESCARGA_NOMINA_EXCEL,
//         key: 'DESCARGA_NOMINA_EXCEL'
//     },
//     {
//         groupId: GROUP_ID.PUESTOS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_PUESTOS_DE_TRABAJO,
//         key: 'GESTION_PUESTOS_DE_TRABAJO'
//     },
//     {
//         groupId: GROUP_ID.PUESTOS,
//         functionalityId: FUNCTIONALITY_ID.ALTA_PUESTO_DE_TRABAJO,
//         key: 'ALTA_PUESTO_DE_TRABAJO'
//     },
//     {
//         groupId: GROUP_ID.PUESTOS,
//         functionalityId: FUNCTIONALITY_ID.EDICION_PUESTO_DE_TRABAJO,
//         key: 'EDICION_PUESTO_DE_TRABAJO'
//     },
//     {
//         groupId: GROUP_ID.PUESTOS,
//         functionalityId: FUNCTIONALITY_ID.INACTIVACION_PUESTO_DE_TRABAJO,
//         key: 'INACTIVACION_PUESTO_DE_TRABAJO'
//     },
//     {
//         groupId: GROUP_ID.VINCULACION_RGRL,
//         functionalityId: FUNCTIONALITY_ID.GESTION_DE_PRESENTACIONES_VINCULACION_RGRL,
//         key: 'GESTION_DE_PRESENTACIONES_VINCULACION_RGRL'
//     },
//     {
//         groupId: GROUP_ID.VINCULACION_RGRL,
//         functionalityId: FUNCTIONALITY_ID.GENERACION_ARCHIVOS_SRT,
//         key: 'GENERACION_ARCHIVOS_SRT'
//     },
//     {
//         groupId: GROUP_ID.VINCULACION_RGRL,
//         functionalityId: FUNCTIONALITY_ID.DESCARGA_PDF,
//         key: 'DESCARGA_PDF'
//     },
//     {
//         groupId: GROUP_ID.VINCULACION_RGRL,
//         functionalityId: FUNCTIONALITY_ID.CARGA_RESPUESTA_SRT,
//         key: 'CARGA_RESPUESTA_SRT'
//     },
//     {
//         groupId: GROUP_ID.VINCULACION_RGRL,
//         functionalityId: FUNCTIONALITY_ID.CONSULTA_DE_PRESENTACIONES_SRT,
//         key: 'CONSULTA_DE_PRESENTACIONES_SRT'
//     },
//     {
//         groupId: GROUP_ID.CANCERIGENOS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_CANCERIGENOS,
//         key: 'GESTION_CANCERIGENOS'
//     },
//     {
//         groupId: GROUP_ID.CANCERIGENOS,
//         functionalityId: FUNCTIONALITY_ID.ALTA_CANCERIGENOS,
//         key: 'ALTA_CANCERIGENOS'
//     },
//     {
//         groupId: GROUP_ID.CANCERIGENOS,
//         functionalityId: FUNCTIONALITY_ID.ALTA_CANCERIGENOS,
//         key: 'ALTA_CANCERIGENOS'
//     },
//     {
//         groupId: GROUP_ID.CANCERIGENOS,
//         functionalityId: FUNCTIONALITY_ID.CONSULTA_CANCERIGENOS,
//         key: 'CONSULTA_CANCERIGENOS'
//     },
//     {
//         groupId: GROUP_ID.VISITAS,
//         functionalityId: FUNCTIONALITY_ID.ALTA_DE_VISITAS,
//         key: 'ALTA_DE_VISITAS'
//     },
//     {
//         groupId: GROUP_ID.VISITAS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_DE_VISITAS,
//         key: 'GESTION_DE_VISITAS'
//     },
//     {
//         groupId: GROUP_ID.VISITAS,
//         functionalityId: FUNCTIONALITY_ID.DESCARGA_DE_ACTA,
//         key: 'DESCARGA_DE_ACTA'
//     },
//     {
//         groupId: GROUP_ID.VISITAS,
//         functionalityId: FUNCTIONALITY_ID.EDICION_ELIMINACION_RGRL_VEROSIMILITUD,
//         key: 'EDICION_ELIMINACION_RGRL_VEROSIMILITUD'
//     },
//     {
//         groupId: GROUP_ID.PERIODICOS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_DE_EMPLEADOS_EXPUESTOS,
//         key: 'GESTION_DE_EMPLEADOS_EXPUESTOS'
//     },
//     {
//         groupId: GROUP_ID.PERIODICOS,
//         functionalityId: FUNCTIONALITY_ID.GESTION_DE_CONVOCATORIAS,
//         key: 'GESTION_DE_CONVOCATORIAS'
//     },
//     {
//         groupId: GROUP_ID.VISITAS_RGRL,
//         functionalityId: FUNCTIONALITY_ID.GENERACION_ARCHIVOS_VISITAS,
//         key: 'GENERACION_ARCHIVOS_VISITAS'
//     }
// ];

// const getAccessValues = (access: Access | null): Features => {
//     const accessValues = {} as Features;
//     functionalities.forEach(({ groupId, functionalityId, key }) => {
//         accessValues[key as FeatureKeys] = {
//             url: getAccessUrl(access, groupId, functionalityId),
//             hasAccess: hasAccess(access, groupId, functionalityId)
//         };
//     });
//     return accessValues;
// };

// export { GROUP_ID, FUNCTIONALITY_ID, getAccessUrl, hasAccess, getAccessValues };
